module.exports = __webpack_public_path__ + "img/bg-faq.dae4d082.jpg";